import { Injectable } from '@angular/core';
import { environment } from '../../../environments/environment'
import { HttpClient } from '@angular/common/http';
import { CacheService, ITypeClosePeriodBO } from '@mapfre-tech/amap3';
import { map } from 'rxjs/operators';

import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class TypeClosePeriodService {

  className = 'TypeClosePeriodService';

  constructor(private http: HttpClient, private cacheService: CacheService) { }

  getAllTypeClosePeriods(cache = true, cacheKey = "allClosePeriod"): Observable<ITypeClosePeriodBO[]> {
    if (this.cacheService.canUseCache(cacheKey) && cache) {
      return this.cacheService.getCacheData(cacheKey) as object as Observable<ITypeClosePeriodBO[]>;
    } else {
      const observable = this.http.get<ITypeClosePeriodBO[]>(environment.base_URL + "/types-close-periods").pipe(map((res) => {
      this.cacheService.updateCacheData(res, cacheKey)
      return res;
      }))
      this.cacheService.updateCacheReq(cacheKey);
      return observable;
    }
  }
    
  newTypeClosePeriod(newTipoCierrePeriodo: ITypeClosePeriodBO): Observable<ITypeClosePeriodBO> {
    return this.http.post<ITypeClosePeriodBO>(environment.base_URL + "/types-close-periods", newTipoCierrePeriodo);
  }

}
